import { PaginaNode, TecnologiaNode } from '@gql/graphql'
import { useTrans, useTransRoute } from 'hooks'
import { PlaceholderReact } from '@components/molecules'
import { GenericHero, Page, Prefooter, TecnologieSection } from 'components/organisms'
import styles from './TecnologieDetailTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  tecnologia?: TecnologiaNode
}

const TecnologieDetailTemplate = (props: Props) => {
  const { pagina = undefined, tecnologia = undefined } = props

  const t = useTrans()
  const tRoute = useTransRoute()
  const defaultContent1 = tecnologia?.pagebuilders?.find((x) => x.key === 'main') ?? null

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero
          pagina={{ ...pagina, titolo: tecnologia.title, descrizione: tecnologia.description }}
        />
        <div className={styles.placeholderContent}>
          <PlaceholderReact
            contentTypeId={tecnologia.model}
            objectId={tecnologia.pk}
            pkey={'main'}
            serverSideContent={defaultContent1}
          />
        </div>
        <TecnologieSection
          tecnologie={tecnologia.correlati}
          item={{
            name: t('Esplora le altre tecnologie'),
            ctaLabel: t('Tutte le tecnologie Emilgroup'),
            url: tRoute('/azienda/tecnologie')?.href,
          }}
          theme="neutral10"
        />
        <Prefooter />
      </main>
    </Page>
  )
}

export default TecnologieDetailTemplate
